import React, { useState, useContext, useEffect } from 'react';
import { observer } from 'mobx-react';
import { StoreContext } from 'index';

import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

const MySwal = withReactContent(Swal);

function DisableNotifications(props) {
  const store = useContext(StoreContext);

  useEffect(() => {
    showConfirmAlert();
  }, []);

  const onConfirm = async () => {
    let { match: { params } } = props;

    store.userStore
      .disableNotification(params.id)
      .then(result => {
        if (result.status === 200) showSuccessAlert();
      });
  };

  const showConfirmAlert = () => {
    MySwal
      .fire({
        title: "Do you want to disable?",
        text: "You will not be notified for any of the future availability against this training.",
        icon: "custom",
        showCancelButton: true,
        confirmButtonText: "Sure",
        cancelButtonText: "No",
        confirmButtonColor: "#d33",
        cancelButtonColor: "#bbb",
      })
      .then((result) => {
        if (result.isConfirmed) {
          onConfirm();
        } else {
          window.close();
        }
      });
  }

  const showSuccessAlert = () => {
    MySwal
      .fire({
        title: "Notifications disabled!",
        icon: "success",
      })
      .then((result) => {
        if (result.isConfirmed) {
          window.close();
        }
      });
  }

  return (<div></div>);
}

export default observer(DisableNotifications);
